import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { SEO } from '../components/SEO';
import { listProjects } from '../portfolio/registry';
import { ProjectCard } from '../portfolio/components/ProjectCard';

export function PortfolioIndexPage() {
  const { t } = useTranslation('common');
  const projects = listProjects();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-dark w-full overflow-hidden">
      <SEO
        title="ผลงานของเรา"
        description="ชมผลงานโปรเจกต์ที่ HappyTech ได้พัฒนาให้กับลูกค้า ตั้งแต่เว็บแอป แอปมือถือ ไปจนถึงระบบองค์กร พร้อม case studies และตัวอย่างการใช้งานจริง"
        url="https://www.happytech.dev/portfolio"
        keywords="portfolio, ผลงาน, โปรเจกต์, showcase, case study, web apps, mobile apps"
      />
      <Header />

      <main className="pt-24 sm:pt-32 pb-20">
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
          <div className="orb absolute top-40 left-1/4 w-96 h-96 bg-neon-cyan/10 rounded-full blur-3xl" />
          <div className="orb-delayed absolute top-1/2 right-1/4 w-[500px] h-[500px] bg-neon-purple/10 rounded-full blur-3xl opacity-50" />
          <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:64px_64px]" />
        </div>

        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 glass rounded-full mb-6">
              <span className="w-2 h-2 bg-neon-green rounded-full animate-pulse" />
              <span className="text-sm font-medium text-neon-green tracking-wide">{t('portfolioIndex.badge')}</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 font-heading">
              <span className="gradient-text">{t('portfolioIndex.pageTitle')}</span>
            </h1>
            <p className="text-lg md:text-xl text-text-secondary leading-relaxed max-w-2xl mx-auto">
              {t('portfolioIndex.pageSubtitle')}
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((p) => (
              <ProjectCard key={p.slug} project={p} />
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
